import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BnNgIdleService } from 'bn-ng-idle';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from "primeng/calendar";
import { CascadeSelectModule } from "primeng/cascadeselect";
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from "primeng/chips";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from "primeng/dropdown";
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from "primeng/inputmask";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from "primeng/multiselect";
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ErrorInterceptor } from './_helpers';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { AlertComponent } from './alert';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DetalleColorComponent } from './detalle-color/detalle-color.component';
import { DetalleFormulaComponent } from './detalle-formula/detalle-formula.component';
import { EnviarNotificacionComponent } from './enviar-notificacion/enviar-notificacion.component';
import { FormulaChildComponent } from './formula-child/formula-child.component';
import { FormulaSearchComponent } from './formula-search/formula-search.component';
import { FormulasColorComponent } from './formulas-color/formulas-color.component';
import { initializeKeycloak } from './init/keycloak-init.factory';
import { NotificacionListComponent } from './notificacion-list/notificacion-list.component';
import { AppConfigService } from './services/config/app.config.service';
import { HashLocationStrategy, LocationStrategy, NgOptimizedImage } from '@angular/common';
@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    KeycloakAngularModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    AutoCompleteModule,
    CalendarModule,
    CheckboxModule,
    ChipsModule,
    DropdownModule,
    InputMaskModule,
    InputNumberModule,
    CascadeSelectModule,
    MultiSelectModule,
    InputTextareaModule,
    InputTextModule,
    TableModule,
    PanelModule,
    DialogModule,
    ChipModule,
    SplitButtonModule,
    MenubarModule,
    MessagesModule,
    MessageModule,
    ConfirmDialogModule,
    ToastModule,
    TabViewModule,
    TooltipModule,
    ButtonModule,
    ScrollPanelModule,
    NgOptimizedImage
],
  declarations: [
    AppComponent,
    AlertComponent,
    FormulaSearchComponent,
    FormulasColorComponent,
    DetalleFormulaComponent,
    FormulaChildComponent,
    DetalleColorComponent,
    AccessDeniedComponent,
    EnviarNotificacionComponent,
    NotificacionListComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, AppConfigService],
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ConfirmationService,
    MessageService,
    BnNgIdleService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

